import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { resetDialog, setOpenDialog } from "slices/appSlice";
import { useDispatch, useSelector } from "react-redux";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function GenericDialog() {
  const {
    dialogMessage: message,
    dialogTitle: title,
    openDialog: open,
    onDialogClose,
  } = useSelector((state) => state.app);

  const dispatch = useDispatch();

  const closeDialog = () => {
    dispatch(setOpenDialog(false));
    if (onDialogClose) {
      onDialogClose();
    }
    dispatch(resetDialog());
  };
  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeDialog}
        aria-describedby="alert-dialog-slide-description"
        sx={{ zIndex: 9999999 }}
      >
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
